// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1603":"npm.core-js","3773":"npm.dompurify","7383":"npm.html2canvas","8727":"npm.canvg"}[chunkId] || chunkId) + "." + {"1603":"2c2b80950e1705353909","3773":"0e41149ab41a195422c2","4964":"85c9ac83819c320ee1a6","7383":"42ce1fa1fd1c0c3db2f2","8727":"8e53ff874b69ffcc1825"}[chunkId] + ".js";
};